// Firebase configuration and initialization
import { initializeApp, getApps } from 'firebase/app';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  setLogLevel,
} from 'firebase/firestore';
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { resolveFirebaseEnvironmentConfig } from './firebaseEnvironment';

const cfg = resolveFirebaseEnvironmentConfig(process.env);
const app = getApps().length ? getApps()[0] : initializeApp(cfg);

// QUIC/WebChannel flakiness + primary lease contention:
// Force long-polling and enable multi-tab persistence.
const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  useFetchStreams: false,
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});

const auth = getAuth(app);
// Make the normal SaaS remembered-session contract explicit. Signing out still
// clears the local Firebase session; server-side preferences and consent remain.
const authPersistenceReady = setPersistence(auth, browserLocalPersistence).catch(() => {
  console.warn('auth_persistence_configuration_failed', {
    errorCategory: 'auth_persistence_configuration_failed',
  });
});
const storage = getStorage(app);

// Reduce log noise outside development
if ((process.env.NODE_ENV || '').toLowerCase() !== 'production') {
  setLogLevel('error');
}

export { app, db, auth, authPersistenceReady, storage };
